import { render } from "./LawyerResultCard.vue?vue&type=template&id=e7ef6572&scoped=true"
import script from "./LawyerResultCard.vue?vue&type=script&lang=js"
export * from "./LawyerResultCard.vue?vue&type=script&lang=js"

import "./LawyerResultCard.vue?vue&type=style&index=0&id=e7ef6572&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7ef6572"]])

export default __exports__